import { render } from "./LeftSide.vue?vue&type=template&id=60410aa1&scoped=true"
import script from "./LeftSide.vue?vue&type=script&lang=js"
export * from "./LeftSide.vue?vue&type=script&lang=js"

import "./LeftSide.vue?vue&type=style&index=0&id=60410aa1&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60410aa1"]])

export default __exports__